import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { LinkProps } from 'react-router';

import { Link } from '../Link/Link';

import { ButtonSizes, ButtonVariant } from './Button.types';

import css from './Button.module.scss';

export type LinkAsButtonProps = {
  isExternal?: boolean;
  title?: string;
  size?: ButtonSizes;
  variant?: ButtonVariant;
  className?: string;
  isAnchor?: boolean;
  isResponsive?: boolean;
  onClick?: () => void;
} & LinkProps &
  PropsWithChildren;

export const LinkAsButton: React.FC<LinkAsButtonProps> = ({
  to,
  isExternal = false,
  title = '',
  size = ButtonSizes.LG,
  variant = ButtonVariant.PRIMARY,
  className = '',
  isAnchor = false,
  children,
  isResponsive,
  onClick,
  ...linkProps
}) => {
  const classList = classNames(
    css['link-as-button'],
    {
      [css[`link-as-button__${size}`]]: size,
      [css[`link-as-button__${variant}`]]: variant,
      [css['link-as-button__is-responsive']]: isResponsive,
    },
    [className],
  );

  const handleExternalClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.();
  };

  const inner = children || <span className="align-text-top">{title}</span>;

  return (
    <Link
      data-testid="internal-link"
      {...linkProps}
      to={to}
      className={classList}
      preventScrollReset={isAnchor}
      data-prevent-scroll-reset={isAnchor}
      isExternal={isExternal}
      aria-label={title}
      role="button"
      onClick={handleExternalClick}
      defaultCssStyles
    >
      {inner}
    </Link>
  );
};
